// Contact Form Phone Mask
document.addEventListener("DOMContentLoaded", () => {

const input = document.querySelector('#masked');
const numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

function handleInput (evt) {
	evt.target.value = phoneMask(evt.target.value)
}

function phoneMask (phone) {
return phone.replace(/\D/g, '')
	.replace(/^(\d{3})/, '($1) ') // Keep the parentheses around the area code
	.replace(/(\d{3})(\d{1,3})/, '$1-$2') // Add a hyphen after the next three digits
	.replace(/(\d{3}-\d{4})\d+$/, '$1'); // Ensure that only four digits are allowed after the hyphen
}

let value = '';
input.addEventListener('input', () => {
	input.value = phoneMask(value);
})

input.addEventListener('keydown', (evt) => {
	if (numbers.includes(evt.key)) {
		if (value.length < 11)
			value += evt.key;
	} else if (evt.key === "Backspace") {
		value = value.slice(0, -1);
	}
})

input.addEventListener('blur', validatePhoneNumber); // Validate the phone number after input loses focus

// Normalize to E.164 before CF7 AJAX sends
const form = input.closest('form');
if (form) {
	form.addEventListener('submit', () => {
		if (value.length === 10) {
			input.value = '+1' + value;
		}
	});
}

function validatePhoneNumber() {
// Check if the phone number is complete
if (input.value.length < 14) { 
	// Create warning message if it doesn't exist
	if (!document.querySelector('#warning')) {
		const warning = document.createElement('span');
		warning.id = 'warning';
		warning.innerText = 'Please type area code with phone number';
		warning.classList.add('wpcf7-not-valid-tip'); // Add a class to the warning span
		input.parentNode.insertBefore(warning, input.nextSibling);
	}
	} else {
		// Remove warning message if it exists
		const warning = document.querySelector('#warning');
		if (warning) {
			warning.parentNode.removeChild(warning);
		}
	}
}

});